import { render } from "./TopBar.vue?vue&type=template&id=2f359042&scoped=true"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=2f359042&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f359042"

export default script